export default "__VITE_ASSET__BdlIA7YO__"